import { CognitoConfigurationDto } from "api/models/authServiceModels.d";

const amplifyLocalStorageKey = "amplify-config";
const federatedLoginError = "federated-login-error";
const ssoReturnUrlKey = "return-url";

export const isAmplifyConfigExists = () => {
  if (!!localStorage.getItem(amplifyLocalStorageKey)) return true;
  else return false;
};

export const getAmplifyConfigFromStorage = (): CognitoConfigurationDto => {
  const cognitoConfig: CognitoConfigurationDto = JSON.parse(
    localStorage.getItem(amplifyLocalStorageKey) ?? "{}"
  );
  return cognitoConfig;
};

export const setAmplifyConfigToStorage = (config: CognitoConfigurationDto) => {
  localStorage.setItem(amplifyLocalStorageKey, JSON.stringify(config));
};

export const setFederatedLoginError = (error: string) => {
  localStorage.setItem(federatedLoginError, error);
};

export const getFederatedLoginError = (): string | undefined => {
  const error = localStorage.getItem(federatedLoginError) ?? undefined;
  return error;
};

export const setSsoReturnUrl = (returnUrl: string) => {
  localStorage.setItem(ssoReturnUrlKey, returnUrl);
};

export const getSsoReturnUrl = (): string | undefined => {
  return localStorage.getItem(ssoReturnUrlKey) ?? undefined;
};

export const removeSsoReturnUrl = () => {
  localStorage.removeItem(ssoReturnUrlKey);
};

export const removeFederatedLoginError = () => {
  localStorage.removeItem(federatedLoginError);
};

export const removeAmplifyConfigFromStorage = () => {
  localStorage.removeItem(amplifyLocalStorageKey);
};

export const signOut = () => {
  const config = getAmplifyConfigFromStorage();
  localStorage.removeItem(amplifyLocalStorageKey);
  location.assign(
    `https://${config.customDomain}/logout?client_id=${config.clientId}&logout_uri=${config.callbackSignOutUrl}`
  );
};
